export const GoodsVideo = () => {}
